<template>
  <div class="text-block c-text-block">
    <h4
      :data-anim="isAnimated ? 'title' : isAnimated"
    >
      <strong v-html="data.title">{{ data.title }}</strong>
    </h4>
    <p
      :data-anim="isAnimated ? 'paragraph' : isAnimated"
      v-html="data.content"
    >
    </p>
  </div>
</template>

<script>
export default {
  name: 'appTextBlock',

  props: {
    data: {
      type: Object,
      requred: true,
    },

    isAnimated: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~sass-mq/mq";
@import '../style/colors';
@import '../style/variables';
@import '../style/functions';

.text-block {
  display: inline-block;

  h4 {
    margin-bottom: 20px;
    text-transform: uppercase;
    font-size: font-size(m);
  }

  p,
  a {
    color: rgba($color-text, 0.75);

    p,
    div {
      position: relative;
      width: 100%;
    }
  }
}
</style>
